import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import { NsDatepicker, DateString } from 'components/common/ns-datepicker/NsDatepicker';
import { DATE_FORMAT } from 'config/app-config';
import { setPsrExpiryDate } from 'state/psr/psr-slice';
import type { PsrPreferencesType } from '../psr-types';

export const testId = 'expiringPsrItemTestId';

export const ExpiringPsrItem = ({
  displayName,
  description,
  code,
  subCode,
  type,
  expiryDate = null
}: PsrPreferencesType) => {
  const dispatch = useDispatch();
  const name = `expiryDate-${code}-${subCode}`;
  const today = moment();
  const minDate = today.format(DATE_FORMAT);
  const maxDate = today
    .clone()
    .add(6, 'years')
    .subtract(1, 'day')
    .format(DATE_FORMAT);

  const handleChange = useCallback(
    (event) => {
      const {
        target: { processedValue: value }
      } = event;

      dispatch(setPsrExpiryDate({ code, subCode, type, expiryDate: value }));
    },
    [dispatch, code, subCode, type]
  );

  return useMemo(() => {
    return (
      <div data-testid={testId}>
        <NsDatepicker
          name={name}
          label={displayName}
          value={expiryDate as DateString} 
          min={minDate as DateString} 
          max={maxDate as DateString} 
          onChange={handleChange}
          helper="Possible end date"
          tipDetails={
            <>
              <p>{description}</p>
              <p>
                Please put in a possible end date of when you think your
                situation might change
              </p>
            </>
          }
        />
      </div>
    );
  }, [
    description,
    displayName,
    name,
    expiryDate,
    minDate,
    maxDate,
    handleChange
  ]);
};
